// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cropped-image {
  max-width: 100%;
}

.cropper {
  margin-bottom: 10px;
}

#filePicker {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/image-upload-modal/image-upload-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACE,mBAAA;AAEF;;AACA;EACI,aAAA;AAEJ","sourcesContent":[".cropped-image {\n    max-width: 100%\n}\n.cropper {\n  margin-bottom: 10px;\n}\n\n#filePicker {\n    display:none;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
